import { IconConfig } from "../types";

export const filter: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 16 16", // Calculé depuis les dimensions des éléments
  elements: [
    {
      type: 'g',
      fill: "current",
      className: "Group-1477",
      transform: "translate(-1470 -355)",
      children: [
        {
          type: 'rect',
          width: 16,
          height: 2,
          className: "Rectangle-499",
          rx: 1,
          transform: "translate(1470 361)"
        },
        {
          type: 'rect',
          width: 16,
          height: 2,
          className: "Rectangle-501",
          rx: 1,
          transform: "translate(1470 366)"
        },
        {
          type: 'circle',
          cx: 2,
          cy: 2,
          r: 2,
          className: "Ellipse-153",
          transform: "translate(1473 355)"
        },
        {
          type: 'circle',
          cx: 2,
          cy: 2,
          r: 2,
          className: "Ellipse-154",
          transform: "translate(1478 360)"
        },
        {
          type: 'circle',
          cx: 2,
          cy: 2,
          r: 2,
          className: "Ellipse-155",
          transform: "translate(1478 365)"
        },
        {
          type: 'rect',
          width: 16,
          height: 2,
          className: "Rectangle-500",
          rx: 1,
          transform: "translate(1470 356)"
        }
      ]
    }
  ]
}
